exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".enter-email {\n  text-align: center; }\n", "", {"version":3,"sources":["/opt/build/repo/src/components/EnterEmailButton/style.scss"],"names":[],"mappings":"AAGA;EACE,mBAAkB,EACnB","file":"style.scss","sourcesContent":["@import '~@/containers/App/styles/vars';\n@import '~include-media';\n\n.enter-email {\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--9-2!./node_modules/postcss-loader/lib??ref--9-3!./node_modules/sass-loader/lib/loader.js??ref--9-4!./src/components/EnterEmailButton/style.scss
// module id = MBtO
// module chunks = 0